import refrigeratorTransferConfig from '../table/configs/refrigerator-transfers.json';
import {Component} from '@angular/core';

@Component({
  selector: 'app-refrigerator-transfers',
  templateUrl: './refrigerator-transfers.component.html'
})

export class RefrigeratorTransfersComponent {

  private configuration: any;
  constructor() {
    this.configuration = refrigeratorTransferConfig;
  }
}
